import _ from 'lodash';

window._ = _;

function RecordInjuryCtrl($rootScope, $scope, $stateParams, toastr, AuthService, AnalysisService, PlayerService) {
  'ngInject';

  $rootScope.$emit('base:sidebarEvent', false, false);

  // ViewModel
  const vm = this;

  if ($stateParams.date) {
    $scope.$parent.playerBase.commonData.date = $stateParams.date;
  }

  const Flatpickr = require('flatpickr');
  const Korean = require("flatpickr/dist/l10n/ko.js").ko;

  $scope.selectPlayer = false;
  $scope.unselectPlayer = true;

  //팀선수 전체 최신 부상 정보
  vm.playersInjuryInfo = [];

  //부상 상세 정보 확인 선수정보
  vm.player = {
    image_url: null,
    back_number: null,
    name: null
  };

  //개인 선수 부상 이력정보
  vm.playerInjuryRecord = [];


  //팀전체 선수 최신 부상 정보 조회
  vm.getInjuryList = function () {
    vm.getInjuryData = {};
    vm.getInjuryData.login_id = vm.appContext.user.login_id;
    vm.getInjuryData.uuid = vm.appContext.user.uuid;
    // vm.getInjuryData.date = '2017.09.19';
    AnalysisService.getInjury(vm.getInjuryData).then(function (res) {
      vm.playersInjuryInfo = [];

      $scope.playerTotal = 0;
      $scope.playerNormal = 0;
      $scope.playerRecovery = 0;
      $scope.playerCare = 0;
      $scope.playerOperation = 0;

      var players = vm.appContext.players.ourTeam.all;
      var data = res.data.data;

      console.log('data', JSON.stringify(data));
      // return;

      for (let i = 0; i < players.length; i++) {
        let user_id = +(players[i].user_id);
        console.log('user_id', user_id);
        let idx = _.findIndex(
          data,
          {
            'user_id': user_id
          }
        );

        // console.log(i, players[i].name, idx)

        if (idx == -1) {
          let injuryInfo = {
            user_id: players[i].user_id,
            user_name: players[i].name,
            state_id: -1,
            state_name: '-',
            date: '-',
            cause_id: -1,
            cause_name: '-',
            part_id: -1,
            part_name: '-',
            cat_id: -1,
            cat_name: '-',
            location_id: -1,
            location_name: '-',
            movement_id: -1,
            movement_name: '-'
          };
          vm.playersInjuryInfo.push(injuryInfo);
          $scope.playerNormal++;
        } else {

          vm.playersInjuryInfo.push(data[idx]);

          // {id: 1, name: "정상"}, {id: 2, name: "치료중"}, {id: 3, name: "회복중"}, {id: 4, name: "수술"}
          if (data[idx].state_id === 1) {
            $scope.playerNormal++;
          }
          if (data[idx].state_id === 2) {
            $scope.playerCare++;
          }
          if (data[idx].state_id === 3) {
            $scope.playerRecovery++;
          }
          if (data[idx].state_id === 4) {
            $scope.playerOperation++;
          }

        }

        $scope.playerTotal++;

      }
    }).catch(function (e) {
      console.log('ERROR', e);
    });
  }

  vm.getInjuryList();

  //선수별 개별 부상 정보 확인
  vm.displayPlayerInjuryInfo = function (id) {

    let user_id = id + '';
    var players = vm.appContext.players.ourTeam.all;
    console.log('aaaa', id, players)
    let idx = _.findIndex(
      players,
      {
        'user_id': user_id
      }
    );
    console.log('idx', idx);
    vm.player.image_url = players[idx].image_url;
    vm.player.back_number = players[idx].back_number;
    vm.player.name = players[idx].name;

    vm.getInjuryData.user_id = user_id;     //특정선수의 부상 정보 이력 조회시 특성선수 user_id입력
    AnalysisService.getInjury(vm.getInjuryData).then(function (res) {
      console.log('getInjury .... ', res);
      var data = res.data;
      $scope.selectedInjuryPlayer = user_id;
      vm.playerInjuryRecord = data.data;
      $scope.selectPlayer = true;
      $scope.unselectPlayer = false;
    });
  };

  //선수별 개별 부상 정보 숨김 - 전체선수 화면 Display
  vm.hidePlayerInjuryInfo = function () {
    vm.player.image_url = '';
    vm.player.back_number = '';
    vm.player.name = '';

    vm.playerInjuryRecord = [];
    vm.getInjuryData.user_id = null;

    $scope.selectPlayer = false;
    $scope.unselectPlayer = true;
  }







  // //현재 page명 세팅
  // $scope.$parent.base.pageStatus = 'teamRecordInjury';

  /**
  * API 호출 시 parameter 로 사용할 변수
  */
  // vm.getInjuryData = $scope.$parent.base.getInjuryData;
  // vm.setInjuryData = $scope.$parent.base.setInjuryData;
  // //user_id 초기화
  // vm.setInjuryData.user_id = null;
  // vm.metaData = $scope.$parent.base.injuryMetaData;


  //선수 목록
  vm.players = null;


  //접속자 로그인 정보
  let userBasicInfo = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid
  }
  $scope.injuryPageInit = function () {
    //팀 전체 선수 목록 조회
    console.log('start : ', userBasicInfo);
    PlayerService.getPlayers(userBasicInfo).then(function (data) {
      vm.players = data.players;
      setPage();
    });
  }


  //선수 선택
  vm.selectInjuryInputedPlayer = function (e, id) {
    if ($scope.selectedInjuryPlayer == id) {
      $scope.selectedInjuryPlayer = null;
    } else {
      $scope.selectedInjuryPlayer = id;
    }
  };



  // 기록
  vm.record = function () {
    console.log(vm.setInjuryData);
    let userId = $scope.selectedInjuryPlayer;
    if (userId) {
      vm.setInjuryData.user_id = userId;
    } else {
      toastr.error('선수를 선택하지 않았습니다!');
      return;
    }

    if (!vm.setInjuryData.date) {
      toastr.error('부상일자를 입력해주십시오');
      return;
    }

    AnalysisService.setInjury(vm.setInjuryData).then(function (data) {
      if (data.result === 'SUC') {
        vm.setInjuryData.date = null;
        toastr.success('저장되었습니다.');
        setPage();
        if ($scope.selectPlayer) {
          vm.getInjuryData.user_id = userId;     //특정선수의 부상 정보 이력 조회시 특성선수 user_id입력
          AnalysisService.getInjury(vm.getInjuryData).then(function (data) {
            $scope.selectedInjuryPlayer = userId;
            vm.playerInjuryRecord = data.data;
          });
        }
      }
    });
  };

  // 삭제
  vm.remove = function (id) {
    let removeInjuryData = {
      login_id: userBasicInfo.login_id,
      uuid: userBasicInfo.uuid,
      injury_id: id
    };

    // 부상정보 삭제
    AnalysisService.removeInjury(removeInjuryData).then(function (data) {
      if (data.result === 'SUC') {
        toastr.success('부상정보가 삭제되었습니다.');

        AnalysisService.getInjury(vm.getInjuryData).then(function (data) {
          vm.playerInjuryRecord = data.data;
          console.log('data', data.data);
        });
      } else {
        toastr.error('부상정보 삭제중 오류가 발생하였습니다.');
      }
    });
  };


  /**
   * select 변경시 값 적용
   */
  // 부상 상태 변경
  $scope.$watch('recordInjury.metaData.state', function (newVal, oldVal) {
    if (newVal) {
      vm.setInjuryData.state_id = newVal.id;
    }
  });

  // 부상 구분 변경
  $scope.$watch('recordInjury.metaData.cause', function (newVal, oldVal) {
    if (newVal) {
      vm.setInjuryData.cause_id = newVal.id;
    }
  });

  // 부상 부위 변경
  $scope.$watch('recordInjury.metaData.part', function (newVal, oldVal) {
    if (newVal) {
      vm.setInjuryData.part_id = newVal.id;
    }
  });

  // 부상 종류 변경
  $scope.$watch('recordInjury.metaData.cat', function (newVal, oldVal) {
    if (newVal) {
      vm.setInjuryData.cat_id = newVal.id;
    }
  });

  // 부상 위치 변경
  $scope.$watch('recordInjury.metaData.location', function (newVal, oldVal) {
    if (newVal) {
      vm.setInjuryData.location_id = newVal.id;
    }
  });

  // 부상 상황 변경
  $scope.$watch('recordInjury.metaData.movement', function (newVal, oldVal) {
    if (newVal) {
      vm.setInjuryData.movement_id = newVal.id;
    }
  });
}

export default {
  name: 'RecordInjuryCtrl',
  fn: RecordInjuryCtrl
};
